import { useState } from 'react';
import { $transferUpdateStatusStore } from '@lib/store';
import { TransferRequestStatusEnum, type TransferRequestResponse } from '@shared/api/rest/transferRequests';
import { TransferModalType } from '@pages';
import { OTPInput } from '../input/otpInput';
import { Button, Spinner, Text } from '@shared/widgets';
import { useUnit } from 'effector-react';

interface PropsType {
  data: TransferRequestResponse;
  setTransfer?: (value: TransferModalType) => void;
  onSubmit?: () => void;
  onClose: () => void;
}

export const OTPModal = (props: PropsType) => {
  const updateStatusStore = useUnit($transferUpdateStatusStore.store);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [otpValue, setOTPValue] = useState<string | null>(null);

  const onSubmitHandle = async () => {
    try {
      setIsLoading(true);
      if (otpValue) {
        await $transferUpdateStatusStore.events.update({
          id: props.data.id,
          status: TransferRequestStatusEnum.Submitted,
          otpCode: otpValue!,
        });
      }
      setIsLoading(false);
      setOTPValue(null);
      props.setTransfer?.(TransferModalType.APPROVE);
      props.onSubmit?.();
      props.onClose();
    } catch {
      setIsLoading(false);
      setOTPValue(null);
      props.onClose();
    }
  };

  return (
    <div className='fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50'>
      <div className='bg-ice dark:bg-soft-black shadow-lg w-full max-w-lg p-6'>
        <Text className='mb-6 text-center' size='3xl'>
          Please enter the one-time code to execute the transaction
        </Text>
        <div className='flex w-full mb-10 mt-6 items-center justify-center'>{isLoading ? <Spinner /> : <OTPInput onComplete={setOTPValue} />}</div>
        <div className='flex gap-3 mt-5'>
          <Button color='outlined' className='rounded' fullWidth onClick={props.onClose}>
            Cancel
          </Button>
          <Button color='primary' className='rounded' fullWidth disabled={!otpValue || updateStatusStore.loading} onClick={onSubmitHandle}>
            Confirm code
          </Button>
        </div>
      </div>
    </div>
  );
};
